import React from "react";
import { format, parse } from "date-fns";
import { OperatingHour } from "@/types/branch";

const formatTime = (time: string) => {
  const parsedTime = parse(time, "HH:mm:ss", new Date());
  return format(parsedTime, "HH:mm");
};

const getMinutesFromTimeString = (timeString: string) => {
  const [hours, minutes] = timeString.split(":").map(Number);
  return hours * 60 + minutes;
};

const sortTimeRanges = (timeRanges: string) => {
  return timeRanges
    .split(", ")
    .sort((a, b) => {
      const timeA = a.split(" - ")[0]; // Get start time of first range
      const timeB = b.split(" - ")[0]; // Get start time of second range
      return getMinutesFromTimeString(timeA) - getMinutesFromTimeString(timeB);
    })
    .join(", ");
};

const mergeOperatingHours = (
  hours: OperatingHour[],
): Record<string, string> => {
  const mergedHours: Record<string, string> = {};

  hours.forEach((hour) => {
    if (!mergedHours[hour.day]) {
      mergedHours[hour.day] = `${formatTime(hour.open_time)} - ${formatTime(
        hour.close_time,
      )}`;
    } else {
      mergedHours[hour.day] += `, ${formatTime(hour.open_time)} - ${formatTime(
        hour.close_time,
      )}`;
    }
  });

  // Sort time ranges for each day
  Object.keys(mergedHours).forEach((day) => {
    mergedHours[day] = sortTimeRanges(mergedHours[day]);
  });

  return mergedHours;
};

const DesktopOperationalTimes: React.FC<{
  operatingHours: OperatingHour[];
}> = ({ operatingHours }) => {
  const mergedHours = mergeOperatingHours(operatingHours);
  const daysOrder = [
    "Monday",
    "Tuesday",
    "Wednesday",
    "Thursday",
    "Friday",
    "Saturday",
    "Sunday",
  ];

  return (
    <div className="bg-blackOnyx px-4 py-5 md:rounded-r-xl">
      <p className="text-2xl font-bold text-white mb-5">Business Hours</p>
      <ul>
        {daysOrder.map((day) => (
          <li key={day} className="flex justify-between py-2">
            <p className="text-base font-bold text-white pr-10">{day}</p>
            <p className="text-base font-normal text-white">
              {mergedHours[day] || "Closed"}
            </p>
          </li>
        ))}
      </ul>
    </div>
  );
};

export default DesktopOperationalTimes;
